const ELEMENT_ID = Object.freeze({
  intercom: 'intercom-container',
  pinwatch: 'pin-settings-watcher',
  salupwatch: 'salon-update-watcher',
  schedscroll: 'scheduler_scroll',
  closepop: 'closePopUp',
  bookside: 'booking-sidebar',
  checkoutSlick: 'slickPay',
  checkoutTerminal: 'useTerminal',
  checkoutCash: 'cashPay',
  recheckout: 'Re-checkout',
  marketingSms: 'marketing-sms',
  payoutPdfTable: 'payoutPdfTable',
  intercomWatch: 'intercom-watcher',
  findMeAsFormFooter: 'form-footer',
  todayColumn: 'todayColumn',
});

// noinspection JSUnusedGlobalSymbols
export default ELEMENT_ID;
